import React, { useEffect, useState } from "react";
import ProductDivisionList from "../../../../components/division/product/ProductDivisionList";
import ProductDivisionView from "../../../../components/division/product/ProductDivisionView";
import FieldForceDivisionList from "../../../../components/division/fieldForce/FieldForceDivisionList";
import DoctorDivisionList from "../../../../components/division/doctors/DoctorDivisionList";
import DoctorDivisionView from "../../../../components/division/doctors/DoctorDivisionView";
import PharmacyDivisionList from "../../../../components/division/pharmacy/PharmacyDivisionList";
import PharmacyDivisionView from "../../../../components/division/pharmacy/PharmacyDivisionView";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import FieldforceDivisionView from "../../../../components/division/fieldForce/FieldForceDivisionView";
import PharmacyVerificationModal from "../../../../components/modals/manufacturer/PharmacyVerificationModal";
import {
  fieldForceDivisionView,
  pharmacyDivisionView,
  productDivisionView,
} from "../../../../redux/actions/manufacturerActions";
import { useDispatch } from "react-redux";

const DivisionViewTabsComponent = ({
  doctorDivisionView,
  //   pharmacyDivisionView,
}) => {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch(); // ACTIVE TAB
  const [activeProduct, setActiveProduct] = useState(11); // ACTIVE PRODUCT TAB
  const [activeFF, setActiveFF] = useState(21); // ACTIVE FIELD FORCE TAB
  const [activeDoctor, setActiveDoctor] = useState(31); // ACTIVE DOCTOR TAB
  const [activePharmacy, setActivePharmacy] = useState(41); // ACTIVE PHARMACY TAB
  const [productDivisionData, setProductDivisionData] = useState([]);
  const [ffDivisionData, setFfDivisionData] = useState([]);
  const [doctorDivisionData, setDoctorDivisionData] = useState([]);
  const [pharmacyDivisionData, setPharmacyDivisionData] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState("");
  const [selectedFfID, setselectedFfID] = useState("");
  const [selectedDoctorID, setSelectedDoctorID] = useState("");
  const [selectedPharmacyID, setSelectedPharmacyID] = useState("");
  const div_id = params?.id.split("&")?.[3];
  const vendor_id = params?.id.split("&")?.[0];
  const pathVerify = location?.pathname;
  const parts = pathVerify.split("/");
  const pathType = parts[parts.length - 3];
  const activeTabData = params?.id.split("&")?.[4];
  const [activeTab, setActiveTab] = useState(activeTabData ?? "Products");
  const activeSectionData = params?.id.split("&")?.[5];
  const [activeSection, setactiveSection] = useState(
    activeSectionData ?? "list"
  );

  console.log(activeTab, activeSection, "activeSection");

  useEffect(() => {
    let activeSectionData = params?.id.split("&")?.[5];
    setactiveSection(activeSectionData ?? "list");
  }, [params?.id]);

  useEffect(() => {
    // setLoading(true);
    dispatch(
      productDivisionView(
        { vendor_id, division_id: div_id },
        onProductDivViewSuccess,
        onProductDivViewError
      )
    );
  }, []);

  useEffect(() => {
    dispatch(
      fieldForceDivisionView(
        { vendor_id, division_id: div_id },
        onFForceDivViewSuccess,
        onFForceDivViewError
      )
    );

    dispatch(
      doctorDivisionView(
        { vendor_id, division_id: div_id },
        onDoctorDivViewSuccess,
        onDoctorDivViewError
      )
    );

    dispatch(
      pharmacyDivisionView(
        { vendor_id, division_id: div_id },
        onPharmacyDivViewSuccess,
        onPharmacyDivViewError
      )
    );
  }, []);

  const onProductDivViewSuccess = (data) => {
    setProductDivisionData(data.data.data);
    console.log(data);
    // setLoading(false);
  };

  const onProductDivViewError = (err) => {
    console.log(err);
    // setLoading(false);
  };

  const onFForceDivViewSuccess = (data) => {
    console.log(data.data.data);
    setFfDivisionData(data.data.data);
  };

  const onFForceDivViewError = (err) => {
    console.log(err);
  };

  const onDoctorDivViewSuccess = (data) => {
    console.log(data);
    setDoctorDivisionData(data.data.data);
  };

  const onDoctorDivViewError = (err) => {
    console.log(err);
  };

  const onPharmacyDivViewSuccess = (data) => {
    console.log(data);
    setPharmacyDivisionData(data.data.data);
  };

  const onPharmacyDivViewError = (err) => {
    console.log(err);
  };

  return (
    <>
      <div className="d-xl-block mx-4">
        <div className="d-flex my-1 py-2 " style={{ overflowX: "scroll" }}>
          <div className="text-nowrap my-1">
            <button
              className={
                activeTab === "Products"
                  ? "topbarTabActive mx-2"
                  : "topTab mx-2"
              }
              onClick={() => {
                setActiveTab("Products");
                navigate(
                  `/manufacturer/${pathType}/view/${vendor_id}&divisions&view&${div_id}&Products&list`
                );
              }}
            >
              Products
            </button>
          </div>
          <div className="text-nowrap my-1">
            <button
              className={
                activeTab == "Fieldforce"
                  ? "topbarTabActive mx-2"
                  : "topTab mx-2"
              }
              onClick={() => {
                setActiveTab("Fieldforce");
                navigate(
                  `/manufacturer/${pathType}/view/${vendor_id}&divisions&view&${div_id}&Fieldforce&list`
                );
              }}
            >
              Field force
            </button>
          </div>
          <div className="text-nowrap my-1">
            <button
              className={
                activeTab === "Doctors" ? "topbarTabActive mx-2" : "topTab mx-2"
              }
              onClick={() => {
                setActiveTab("Doctors");
                navigate(
                  `/manufacturer/${pathType}/view/${vendor_id}&divisions&view&${div_id}&Doctors&list`
                );
              }}
            >
              Doctors
            </button>
          </div>
          <div className="text-nowrap my-1">
            <button
              className={
                activeTab === "Pharmacies"
                  ? "topbarTabActive mx-2"
                  : "topTab mx-2"
              }
              onClick={() => {
                setActiveTab("Pharmacies");
                navigate(
                  `/manufacturer/${pathType}/view/${vendor_id}&divisions&view&${div_id}&Pharmacies&list`
                );
              }}
            >
              Pharmacies
            </button>
          </div>
        </div>
      </div>

      <div className="px-3 py-2">
        {activeTab === "Products" && (
          <>
            {activeSection === "list" && (
              <ProductDivisionList
                setActiveProduct={setActiveProduct}
                productDivisionData={productDivisionData}
                setSelectedProductId={setSelectedProductId}
              />
            )}
            {activeSection === "view" && (
              <ProductDivisionView
                selectedProductId={selectedProductId}
                setActiveProduct={setActiveProduct}
              />
            )}
          </>
        )}
        {activeTab === "Fieldforce" && (
          <>
            {activeSection === "list" && (
              <FieldForceDivisionList
                setActiveFF={setActiveFF}
                ffDivisionData={ffDivisionData}
                setselectedFfID={setselectedFfID}
              />
            )}
            {activeSection === "view" && (
              <FieldforceDivisionView setActiveFF={setActiveFF} />
            )}
          </>
        )}
        {activeTab === "Doctors" && (
          <>
            {activeSection === "list" && (
              <DoctorDivisionList
                setActiveDoctor={setActiveDoctor}
                doctorDivisionData={doctorDivisionData}
                setSelectedDoctorID={setSelectedDoctorID}
                vendor_Id={vendor_id}
                division_id={div_id}
                doctorDivisionView={doctorDivisionView}
              />
            )}
            {activeSection === "view" && (
              <DoctorDivisionView
                setActiveDoctor={setActiveDoctor}
                selectedDoctorID={selectedDoctorID}
              />
            )}
          </>
        )}
        {activeTab === "Pharmacies" && (
          <>
            {activeSection === "list" && (
              <PharmacyDivisionList
                setActivePharmacy={setActivePharmacy}
                pharmacyDivisionData={pharmacyDivisionData}
                setSelectedPharmacyID={setSelectedPharmacyID}
                // pharmacyDivisionView={pharmacyDivisionView}
                vendor_Id={vendor_id}
                division_id={div_id}
              />
            )}
            {activeSection === "view" && (
              <PharmacyDivisionView
                setActivePharmacy={setActivePharmacy}
                selectedPharmacyID={selectedPharmacyID}
              />
            )}
          </>
        )}
      </div>
    </>
  );
};

export default DivisionViewTabsComponent;
